import React, { useState, useEffect } from "react";
import "./cc.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

const LoanCollection = () => {
  const [accountNumber, setAccountNumber] = useState("");
  const [collectionDate, setCollectionDate] = useState("");
  const [loanData, setLoanData] = useState(null);
  const [text, settext] = useState("");

  // Demo API fetch
  const handleFindLoan = async () => {
    if (!accountNumber || !collectionDate) return; // Don’t fetch if empty
    const demoApiResponse = {
      customerName: "Mani Miraz",
      loanAccountNo: "500001",
      loanType: "CC Loan",
      loanAmount: 50000,
      balanceLoanAmount: 50000,
      interestRate: 5,
      penalInterest: 0,
      loanSince: "2025-10-20",
      recoveryFreq: "M",
      tillDate: {
        principal: 50000,
        interest: 0,
        penalty: 0,
        net: 50000,
      },
      pendingPayment: {
        principal: 50000,
        interest: 0,
        penalty: 0,
        net: 50000,
      },
      mode: { mode: "" }, // Added mode field

        collectionDate: collectionDate,
        accountNumber: accountNumber,
    };
    setLoanData(demoApiResponse);
  };

  // Auto-fetch when accountNumber or collectionDate changes
  useEffect(() => {
    handleFindLoan();
  }, [accountNumber, collectionDate]);

  return (
    <div className="CCloan-collection-container">
      {/* 🔍 Search Section */}
      <div className="CCsearch-box">
        <div>
          <label>Account Number</label>
          <input
            type="text"
            value={accountNumber}
            onChange={(e) => setAccountNumber(e.target.value)}
            placeholder="Enter Account Number"
          />
        </div>
        <div>
          <label>Collection Date</label>
          <input
            type="date"
            value={collectionDate}
            onChange={(e) => setCollectionDate(e.target.value)}
          />
        </div>
        <button onClick={handleFindLoan}>
          <i className="fas fa-search"></i> Find Loan
        </button>
      </div>

      {/* Loan Details */}
      {loanData && (
        <>
          <div className="CCloan-details">
            <div>
              <label>Customer Name</label>
              <input type="text" value={loanData.customerName} />
            </div>
            <div>
              <label>Loan Account Number</label>
              <input type="text" value={loanData.loanAccountNo} />
            </div>
            <div>
              <label>Loan Type</label>
              <input type="text" value={loanData.loanType} />
            </div>
            <div>
              <label>Loan Amount</label>
              <input type="number" value={loanData.loanAmount} />
            </div>
            <div>
              <label>Balance Loan Amount</label>
              <input type="number" value={loanData.balanceLoanAmount} />
            </div>
            <div>
              <label>Interest Rate (%)</label>
              <input type="number" value={loanData.interestRate} />
            </div>
            <div>
              <label>Penal Interest (%)</label>
              <input type="number" value={loanData.penalInterest} />
            </div>
            <div>
              <label>Loan Since</label>
              <input type="text" value={loanData.loanSince} />
            </div>
            <div>
              <label>Recovery Freq</label>
              <input type="text" value={loanData.recoveryFreq} />
            </div>
          </div>

          {/* Loan Till Date */}
          <div className="CCloan-card green">
            <h3>Loan Till Date</h3>
            <div className="CCloan-stats">
              <div>
                <i className="fas fa-coins"></i>
                <p>Principal</p>
                <span>{loanData.tillDate.principal}</span>
              </div>
              <div>
                <i className="fas fa-percent"></i>
                <p>Interest</p>
                <span>{loanData.tillDate.interest}</span>
              </div>
              <div>
                <i className="fas fa-exclamation-triangle"></i>
                <p>Penalty</p>
                <span>{loanData.tillDate.penalty}</span>
              </div>
              <div>
                <i className="fas fa-calculator"></i>
                <p>Net</p>
                <span>{loanData.tillDate.net}</span>
              </div>
            </div>
          </div>

          {/* Pending Payment */}
          <div className="CCloan-card yellow">
            <h3>Pending Payment Overall Loan</h3>
            <div className="CCloan-stats">
              <div>
                <i className="fas fa-coins"></i>
                <p>Principal</p>
                <span>{loanData.pendingPayment.principal}</span>
              </div>
              <div>
                <i className="fas fa-percent"></i>
                <p>Interest</p>
                <span>{loanData.pendingPayment.interest}</span>
              </div>
              <div>
                <i className="fas fa-exclamation-triangle"></i>
                <p>Penalty</p>
                <span>{loanData.pendingPayment.penalty}</span>
              </div>
              <div>
                <i className="fas fa-calculator"></i>
                <p>Net</p>
                <span>{loanData.pendingPayment.net}</span>
              </div>
            </div>
          </div>
               
            {/* Collection Details */}

             <div className="CCCollection-Details">
               <h3>Collection Details</h3>
               <div className="CCCollection-status">
                 <div>
                     <p>Mode</p>
                        <select>
                            <option value="cash">Cash</option>
                            <option value="cheque">Cheque</option>
                            <option value="online">Online Transfer</option>
                        </select><span>{loanData.mode.mode}</span>
                    </div>
                    <div>
                        <p>Total Collection Amount</p>
                        <input type="number" value={loanData.loanAmount} />
                       </div>
                       <div>
                        <p>Remarks</p>
                        <input
              type="text"
            value={text}
            onChange={(e) => settext(e.target.text)}
            placeholder="Enter Remarks"
            className="CCremarks"
            />
                       </div>
                    </div>
                    <div className="CCsubmit-button">
                        <button type="Submit">Submit Collection</button>
                        
                    </div>
                    </div>
                    
          
        </>
      )};
    </div>
  );
};

export default LoanCollection;
